import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DateTimeRange from "../../../components/common/DateTimeRange";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";
import $, { error } from "jquery";
import { toast } from "react-toastify";
import moment from "moment";
import { View, ViewOff } from "@carbon/icons-react";
import { ValidateEmail } from "../../../Utils/regexFunctions";

const AddCompany = () => {
  const { auth } = useAuth();
  const [company, setCompany] = useState();
  const [viewPassword, setViewPassword] = useState(false);
  const [viewPassword1, setViewPassword1] = useState(false);
  const [callType, setCallType] = useState();
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [pwdPassword, setPwdPassword] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [workNumberError, setWorkNumberError] = useState("");
  const [fileUploadError, setFileUploadError] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [noOfDepartError, setnoOfDepartError] = useState("");
  const [companyNameLength, setCompanyNameLength] = useState("");
  const [ntnLength, setNtnLength] = useState("");
  const [inboundChecked, setInboundChecked] = useState(true);

  const [submittedData, setSubmittedData] = useState({
    company_name: "",
    // ntn: "",
    nature_of_companies: "",
    address: "",
    user_name: "",
    email: "",
    work_number: "",
    mobile_number: "",
    password: "",
    password_confirm: "",
    diodid: "",
    package_id: "",
    number_of_depart: "",
    call_type: "",
    // inbound_recording: "",
    // outbound_recording: "",
    // extension_recording: "",
    // package_activation_datetime: "",
    // package_inactivation_datetime: "",
    extensionfile: "",
  });

  // console.log("submittedData", submittedData.call_type);
  // const ValidateEmail = (value) => {
  //   var mailformat = /^[A-Za-z][\w$.]+@[\w]+\.\w+$/;
  //   if (mailformat.test(value)) {
  //     return "Valid Email";
  //   } else {
  //     return "Invalid Email";
  //   }
  // };
  const handleConfirmPwdValidation = (e) => {
    if (e === submittedData.password && e.length >= 5) {
      setPwdPassword(true);
    } else {
      setPwdPassword(false);
    }
  };
  const handlePasswordValidation = (e) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/;
    let testedPassword = passwordRegex.test(e);
    if (testedPassword === false) {
      setPasswordError("Validation error");
    } else if (e.length < 14) {
      setPasswordError("Invalid password");
    } else {
      setPasswordError("");
    }

    // if(submittedData.password_confirm==='')
  };
  const userNamValidation = (e) => {
    if (e.length < 5) {
      setUserNameError("short"); // Username is too short
    } else if (e.length > 45) {
      setUserNameError("long"); // Username is too long
    } else {
      setUserNameError(""); // Username is valid
    }
  };

  const numberofDepartValidation = (e) => {
    if (e.length < 1) {
      setnoOfDepartError("short"); // Username is too short
    } else if (e.length > 45) {
      setnoOfDepartError("long"); // Username is too long
    } else {
      setnoOfDepartError(""); // Username is valid
    }
  };
  const handleEmailValidation = (e) => {
    var Email = ValidateEmail(e);
    if (Email === "Invalid Email") {
      setEmailError("Invalid Email Address");
    } else {
      setEmailError("Valid Email Address");
    }
  };
  const handleMobileNumberValidation = (e) => {
    if (e.length !== 11) {
      setMobileNumberError("Invalid mobile number");
    } else {
      setMobileNumberError("");
    }
  };
  const handleWorkNumberValidation = (e) => {
    if (e.length !== 11) {
      setWorkNumberError("Invalid mobile number");
    } else {
      setWorkNumberError("");
    }
  };

  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    if (fileExtensionName !== "csv") {
      setFileUploadError("Please upload csv format file");
      setSubmittedData({
        ...submittedData,
        extensionfile: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        extensionfile: file,
      });
    }
  };

  const handleViewPassword = () => {
    setViewPassword(!viewPassword);
  };

  const handleViewPassword2 = () => {
    setViewPassword1(!viewPassword1);
  };

  const getCallApi = () => {
    axios
      .post(
        url + "getCallType",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setCallType([]);
            } else if (response.data.message === "Data Found") {
              setCallType(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getCompany = () => {
    axios
      .post(
        url + "create-company",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setCompany([]);
            } else if (response.data.message === "Data Found") {
              setCompany(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const createCompany = (e) => {
    e.preventDefault();
    setErrorEnable(true);
    setLoader(true);

    var inbound_checkbox =
      $("#inbound_checkbox").is(":checked") === true ? 1 : 0;
    var outbound_checkbox =
      $("#outbound_checkbox").is(":checked") === true ? 1 : 0;
    var extension_checkbox =
      $("#extension_checkbox").is(":checked") === true ? 1 : 0;
    var formData = new FormData();
    formData.append("company_name", submittedData.company_name);
    formData.append("user_name", submittedData.user_name);
    formData.append("number_of_depart", submittedData.number_of_depart);
    formData.append("address", submittedData.address);
    // formData.append("ntn", submittedData.ntn);
    formData.append("email", submittedData.email);
    formData.append("work_number", submittedData.work_number);
    formData.append("mobile_number", submittedData.mobile_number);
    formData.append("password", submittedData.password);
    formData.append("password_confirm", submittedData.password_confirm);
    formData.append("diodid", submittedData.diodid);
    formData.append("nature_of_companies", submittedData.nature_of_companies);
    formData.append("call_type", submittedData.call_type);
    formData.append("package_id", submittedData.package_id);
    formData.append("inbound_recording", inbound_checkbox);
    formData.append("outbound_recording", outbound_checkbox);
    formData.append("extension_recording", extension_checkbox);
    formData.append(
      "package_activation_datetime",
      moment(startDate).format("YYYY-MM-DD")
    );
    formData.append(
      "package_inactivation_datetime",
      moment(endDate).format("YYYY-MM-DD")
    );
    formData.append("extensionfile", submittedData.extensionfile);

    if (
      submittedData.company_name !== "" &&
      // submittedData.ntn !== "" &&
      submittedData.nature_of_companies !== "" &&
      submittedData.call_type !== "" &&
      submittedData.address !== "" &&
      submittedData.user_name !== "" &&
      submittedData.number_of_depart !== "" &&
      submittedData.work_number !== "" &&
      submittedData.mobile_number !== "" &&
      submittedData.email !== "" &&
      submittedData.diodid !== "" &&
      submittedData.package_id !== "" &&
      submittedData.password !== "" &&
      submittedData.password_confirm !== "" &&
      submittedData.extensionfile !== "" &&
      startDate !== "" &&
      endDate !== "" &&
      emailError === "Valid Email Address" &&
      pwdPassword === true &&
      passwordError === "" &&
      mobileNumberError === "" &&
      workNumberError === "" &&
      fileUploadError === "" &&
      userNameError === "" &&
      noOfDepartError === "" &&
      companyNameLength === ""
      // ntnLength === ""
    ) {
      axios
        .post(url + "store-company", formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.data.code === 200) {
              if (
                response?.data?.message === "Company user added successfully."
              ) {
                setLoader(false);
                toast.success(response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/companies";
                }, 2000);
              }
            } else if (response.data.code === 400) {
              {
                setLoader(false);
                toast.error(response?.data?.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
              }
            } else {
              // console.log(response?.data?.data?.hasOwnProperty("email")=== true);
              // if (response?.data?.data?.hasOwnProperty("errors") == true) {
              if (response?.data?.data?.errors !== undefined) {
                toast.error(
                  response?.data?.data?.errors[0] ||
                    response?.data?.data?.email,
                  {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  }
                );
                setLoader(false);
              }
              // if (response?.data?.data?.hasOwnProperty("email") == true) {
              if (response?.data?.data?.email !== undefined) {
                toast.error(response?.data?.data?.email, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setLoader(false);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (auth.role !== "1") {
      window.location.href = "/";
    }
    getCompany();
  }, []);

  useEffect(() => {
    getCallApi();
  }, []);

  // Function to handle checkbox changes
  const handleCheckboxChange = () => {
    // Toggle the checked state
    setInboundChecked(!inboundChecked);
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-1-1">
              <div className="dashboardIntro">
                <Link to="/companies">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX Manager</span>
                </Link>
                <h3>CREATE COMPANY</h3>
                <p>
                  Please enter the details for the new company, add user
                  information, select a master number and package.
                </p>
              </div>
            </div>
          </div>
          <form onSubmit={createCompany}>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Company information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Company name</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Company name"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        company_name: e.target.value,
                      });
                      e.target.value.length < 5
                        ? setCompanyNameLength("invalid")
                        : setCompanyNameLength("");
                    }}
                  />
                  {errorEnable && submittedData.company_name === "" && (
                    <div className="formErrors">Company is required</div>
                  )}
                  {errorEnable &&
                    submittedData.company_name !== "" &&
                    companyNameLength !== "" && (
                      <div className="formErrors">
                        company name must be 5 character long
                      </div>
                    )}
                </div>

                {/* <div className="uk-width-1-2@m uk-margin-top">
                  <label>NTN/VAT/Tax ID</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Company NTN / VAT / Tax ID"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        ntn: e.target.value,
                      });
                      e.target.value.length < 5
                        ? setNtnLength("invalid")
                        : setNtnLength("");
                    }}
                  />
                  {errorEnable && submittedData.ntn === "" && (
                    <div className="formErrors">Ntn is required</div>
                  )}
                  {errorEnable &&
                    submittedData.ntn !== "" &&
                    ntnLength !== "" && (
                      <div className="formErrors">
                        ntn must be 5 character long
                      </div>
                    )}
                </div> */}
                <div className="uk-width-1-2@m uk-margin-top uk-position-relative">
                  <label>Password</label>
                  <input
                    className="uk-input"
                    type={viewPassword1 ? "text" : "password"}
                    aria-label="Input"
                    placeholder="Enter Password"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password: e.target.value,
                      });
                      handlePasswordValidation(e.target.value);
                    }}
                  />

                  <div
                    style={{ position: "absolute", top: "36px", right: "10px" }}
                  >
                    {viewPassword ? (
                      <ViewOff
                        className="viewIcon"
                        onClick={handleViewPassword2}
                      />
                    ) : (
                      <View
                        className="viewIcon"
                        onClick={handleViewPassword2}
                      />
                    )}
                  </div>
                  {errorEnable && submittedData.password === "" && (
                    <div className="formErrors">Password is required</div>
                  )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Invalid password" && (
                      <div className="formErrors">
                        password must be 14 characters
                      </div>
                    )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Validation error" && (
                      <div className="formErrors">
                        password must includes uppercase, lowercase, numbers and
                        special characters
                      </div>
                    )}
                </div>
                <div className="uk-width-1-2@m uk-margin-top uk-position-relative">
                  <label>Confirm password</label>
                  <input
                    className="uk-input"
                    type={viewPassword ? "text" : "password"}
                    aria-label="Input"
                    placeholder="enter confirm password"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password_confirm: e.target.value,
                      });
                      handleConfirmPwdValidation(e.target.value);
                    }}
                  />

                  <div
                    style={{ position: "absolute", top: "36px", right: "10px" }}
                  >
                    {viewPassword ? (
                      <ViewOff
                        className="viewIcon"
                        onClick={handleViewPassword}
                      />
                    ) : (
                      <View className="viewIcon" onClick={handleViewPassword} />
                    )}
                  </div>
                  {errorEnable && submittedData.password_confirm === "" && (
                    <div className="formErrors">
                      Confirm password is required
                    </div>
                  )}
                  {submittedData.password_confirm !== "" &&
                    errorEnable &&
                    pwdPassword === false && (
                      <div className="formErrors">
                        password and confirm password not matched{" "}
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Nature of company</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        nature_of_companies: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select company type...
                    </option>
                    {company?.nature_of_companies?.map((val, index) => {
                      return (
                        <option key={index} value={val.id}>
                          {val.title}
                        </option>
                      );
                    })}
                  </select>
                  {errorEnable && submittedData.nature_of_companies === "" && (
                    <div className="formErrors">
                      Please select nature of caompany
                    </div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Number of department</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="Number of department"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        number_of_depart: e.target.value,
                      });
                      numberofDepartValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.number_of_depart === "" && (
                    <div className="formErrors">
                      Number of department is required
                    </div>
                  )}
                  {errorEnable &&
                    submittedData.number_of_depart !== "" &&
                    noOfDepartError !== "" && (
                      <div className="formErrors">
                        {noOfDepartError === "short" &&
                          "Number of department must be greater than 1 characters"}
                        {noOfDepartError === "long" &&
                          "Number of department must be less than 45 characters"}
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Call Type</label>

                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        call_type: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select Call type...
                    </option>
                    {callType?.map((val, index) => {
                      return (
                        <option key={index} value={val.type}>
                          {val.name}
                        </option>
                      );
                    })}
                  </select>

                  {errorEnable && submittedData.call_type === "" && (
                    <div className="formErrors">Please select call type</div>
                  )}
                </div>
                <div className="uk-width-1-1@m uk-margin-top">
                  <label>Address</label>
                  <textarea
                    className="uk-textarea"
                    rows="2"
                    aria-label="Textarea"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        address: e.target.value,
                      });
                    }}
                    placeholder="Address......"
                  ></textarea>
                  {errorEnable && submittedData.address === "" && (
                    <div className="formErrors">Address is required</div>
                  )}
                </div>

                {/* user info start */}

                <div className="uk-width-1-1@m uk-margin-large-top">
                  <legend className="uk-legend">User information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Name</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's name"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        user_name: e.target.value,
                      });
                      userNamValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.user_name === "" && (
                    <div className="formErrors">Name is required</div>
                  )}
                  {errorEnable &&
                    submittedData.user_name !== "" &&
                    userNameError !== "" && (
                      <div className="formErrors">
                        {userNameError === "short" &&
                          "User name must be greater than 5 characters"}
                        {userNameError === "long" &&
                          "User name must be less than 45 characters"}
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Work number</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's work number"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        work_number: e.target.value,
                      });
                      handleWorkNumberValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.work_number === "" && (
                    <div className="formErrors">Work number is required</div>
                  )}
                  {submittedData.work_number !== "" &&
                    errorEnable &&
                    workNumberError === "Invalid mobile number" && (
                      <div className="formErrors">
                        work number must be 11 charcters long
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Mobile number</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's mobile number"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        mobile_number: e.target.value,
                      });
                      handleMobileNumberValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.mobile_number === "" && (
                    <div className="formErrors">Mobile number is required</div>
                  )}
                  {submittedData.mobile_number !== "" &&
                    errorEnable &&
                    mobileNumberError === "Invalid mobile number" && (
                      <div className="formErrors">
                        mobile number must be 11 charcters long
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Email</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    placeholder="User's email address"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        email: e.target.value,
                      });
                      handleEmailValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.email === "" && (
                    <div className="formErrors">Email is required</div>
                  )}
                  {submittedData.email !== "" &&
                    errorEnable &&
                    emailError !== "Valid Email Address" && (
                      <div className="formErrors">Invalid Email Address</div>
                    )}
                </div>

                {/* package info start */}

                <div className="uk-width-1-1@m uk-margin-large-top">
                  <legend className="uk-legend">Package information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>Package/Bucket Activation Date Range</label>
                  <DateTimeRange
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                  />
                  {errorEnable && startDate === "" && endDate === "" && (
                    <div className="formErrors">During period is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Master No. DIOD</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        diodid: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select master no...
                    </option>
                    {company?.package_diod?.map((val, index) => {
                      return (
                        <option key={index} value={val.diod}>
                          {val.diod}
                        </option>
                      );
                    })}
                  </select>

                  {errorEnable && submittedData.diodid === "" && (
                    <div className="formErrors">Please select master no</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Package</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        package_id: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select package...
                    </option>
                    {company?.package_drop_down?.map((val, index) => {
                      return (
                        <option key={index} value={val.package_id}>
                          {val.name}
                        </option>
                      );
                    })}
                  </select>

                  {errorEnable && submittedData.package_id === "" && (
                    <div className="formErrors">Please select package</div>
                  )}
                </div>

                <div className="uk-width-1-1@m uk-margin">
                  <label>
                    <b>Voice Recording</b>
                  </label>
                  <div className="uk-grid" uk-grid>
                    <div className="uk-width-1-6@m">
                      <label className="CheckBoxLabel">
                        <input
                          className="uk-checkbox"
                          type="checkbox"
                          id="inbound_checkbox"
                          checked={inboundChecked}
                          onChange={handleCheckboxChange}
                        />{" "}
                        <span>Inbound</span>
                      </label>
                    </div>
                    <div className="uk-width-1-6@m">
                      <label className="CheckBoxLabel">
                        <input
                          className="uk-checkbox"
                          type="checkbox"
                          id="outbound_checkbox"
                        />{" "}
                        <span>Outbound</span>
                      </label>
                    </div>
                    <div className="uk-width-1-6@m">
                      <label className="CheckBoxLabel">
                        <input
                          className="uk-checkbox"
                          type="checkbox"
                          id="extension_checkbox"
                        />{" "}
                        <span>Extension</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="uk-width-1-1@m uk-margin-top">
                  <label>
                    <b>Please Select Any One Flow Extensions(File input)</b>
                  </label>
                  {/* <span className="fileDisc">
                    Only .zip ﬁles.900kb max ﬁle size.
                  </span> */}
                  <div className="uk-margin-bottom">
                    <div uk-form-custom="target: true">
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".csv"
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />
                      {errorEnable && submittedData.extensionfile === "" && (
                        <div className="formErrors">Please upload file</div>
                      )}
                      {errorEnable && fileUploadError !== "" && (
                        <div className="formErrors">{fileUploadError}</div>
                      )}
                    </div>
                    {/* <button className="uk-button fileUploadBtn uk-button-default">Submit</button> */}
                  </div>
                  <a
                    href={
                      "https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/extensions_sample.csv"
                    }
                    className="DownloadFileBtn"
                  >
                    Download sample file
                  </a>
                </div>
                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    <Link to="/companies" type="button" className="whiteBtn">
                      Cancel
                    </Link>
                    <button className="pinkBtn" type="submit">
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        " Create company"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCompany;
